import React, { createContext, useState, useContext } from "react";

export const AppStateContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <AppStateContext.Provider value={{ loading, setLoading }}>
      {children}
    </AppStateContext.Provider>
  );
};

export const useAppContext = () => useContext(AppStateContext);
